import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container mx-auto grid grid-cols-12 gap-5 py-12 h-full items-center" }
const _hoisted_2 = { class: "col-span-12 md:col-span-6 text-center md:text-start text-white" }
const _hoisted_3 = { class: "flex justify-center md:justify-start gap-x-8 flex-col md:flex-row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center md:justify-start flex-wrap gap-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "bg-gray-800 bg-no-repeat bg-cover bg-center select-none px-5 md:px-8 rounded-md shadow-md mt-10 mx-2",
    style: _normalizeStyle(_ctx.backgroundImage(_ctx.course?.file?.url || _ctx.emptyImg))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.course?.name), 1),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.course?.duration)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Duração estimada do curso: ",
                en: "Estimated course duration: ",
              })) + " " + _toDisplayString(_ctx.generics.getDurationTime(_ctx.course?.duration)), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.course?.categories?.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course?.categories, (item, i) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "px-3 py-1 bg-gray-300 text-black text-sm font-medium rounded-full",
                  key: i
                }, _toDisplayString(item?.name), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 4))
}